import { Regions } from '@wicadu/langscope'

import globalTranslations from '@translations/pages/orders/how-to-cancel-orders/global'

export const HOW_TO_CANCEL_ORDERS_TRANSLATIONS = {
  [Regions.Global]: globalTranslations,
} as const
